import type React from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';
import { Box, Container } from '@change-corgi/design-system-legacy/layout';
import { useColor } from '@change-corgi/design-system-legacy/theme';

import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from 'src/app/pages/petitionDetails/pageContext';
import { ScrollContainer } from 'src/app/shared/components/ScrollContainer';

import { PetitionStrengthCard, TipCard } from './components';
import { useGetPetitionStrengthTips } from './hooks/useGetPetitionStrengthTips';

export const StrengthTips: React.FC = () => {
	const { translate } = useI18n();
	const {
		data: {
			score,
			featureConfigs: { strengthTipsEnabled },
		},
	} = usePetitionDetailsPageData();
	const {
		data: { ownPetition },
	} = usePetitionDetailsPageUserData();

	const tips = useGetPetitionStrengthTips();
	const background = useColor('primary-greyBackground');

	if (!strengthTipsEnabled) {
		return null;
	}

	if (!ownPetition) {
		return null;
	}

	if (tips.length === 0) {
		return null;
	}

	return (
		<Box backgroundColor={background}>
			<Container pt={24} pb={[14, 24]}>
				<ScrollContainer
					label={translate('corgi.petition.details.strength_score.title')}
					backgroundColor={background}
					sx={{
						paddingLeft: [0, 8],
						// list padding ensures the content itself extends to the edge of the page
						'& > #scroll-container-list': {
							scrollPaddingInline: [16, 0],
							pl: [16, 0],
							pr: [16, 8],
						},
						width: 'max-content',
						maxWidth: '100%',
					}}
				>
					<PetitionStrengthCard score={score} />
					{tips.map((tip) => {
						return <TipCard key={`tip-card-${tip.type}`} tip={tip} />;
					})}
				</ScrollContainer>
			</Container>
		</Box>
	);
};
